/** "1 match" / "12 matches": picks the form that agrees with the count. */
export const pluralize = (
  count: number,
  singular: string,
  plural: string
): string => `${count} ${count === 1 ? singular : plural}`;

/** "1 dokument" / "7 dokumenter" — the count labels the staircase uses everywhere. */
export const documentCountLabel = (count: number): string =>
  pluralize(count, "dokument", "dokumenter");

export const workspaceCountLabel = (count: number): string =>
  pluralize(count, "workspace", "workspaces");
